/** Side menu opens Pandoy as a page. The corner button keeps the popup. */
export const OPEN_PANDOY_EVENT = 'digisaka:open-pandoy';
export const CLOSE_PANDOY_EVENT = 'digisaka:close-pandoy';

export type PandoyOpenMode = 'popup' | 'page';

export function requestOpenPandoy(mode: PandoyOpenMode = 'popup'): void {
  window.dispatchEvent(new CustomEvent(OPEN_PANDOY_EVENT, { detail: { mode } }));
}

export function requestClosePandoy(): void {
  window.dispatchEvent(new Event(CLOSE_PANDOY_EVENT));
}
